import { render } from "./ProposalCreateView.vue?vue&type=template&id=7f90ee0e"
import script from "./ProposalCreateView.vue?vue&type=script&lang=js"
export * from "./ProposalCreateView.vue?vue&type=script&lang=js"

import "./ProposalCreateView.vue?vue&type=style&index=0&id=7f90ee0e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__